import { render, staticRenderFns } from "./popupImage.vue?vue&type=template&id=75b8c654&scoped=true"
import script from "./popupImage.vue?vue&type=script&lang=js"
export * from "./popupImage.vue?vue&type=script&lang=js"
import style0 from "./popupImage.vue?vue&type=style&index=0&id=75b8c654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b8c654",
  null
  
)

export default component.exports